module.exports = __webpack_public_path__ + "static/img/image_recruit_12.7269e58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/image_recruit_12.png
// module id = Zb3H
// module chunks = 10